var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96912 12.3851L18.0233 2.2818C18.3973 1.90607 19.0035 1.90607 19.3774 2.2818L20.9999 3.91226L19.6311 4.07732L19.7954 5.78289L18.4266 5.94795L18.5909 7.65353L17.2221 7.81859L17.3863 9.52417L16.0175 9.68922L16.1818 11.3948L14.813 11.5599L14.9773 13.2654L13.6085 13.4305L13.7727 15.1361L12.4039 15.3011L12.5682 17.0067L7.96912 12.3851Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28043 16.9168C2.90652 16.541 2.90652 15.9318 3.28043 15.5561L6.52551 12.2952C6.89942 11.9195 7.50565 11.9195 7.87956 12.2952L12.6577 17.0966C13.0316 17.4724 13.0316 18.0815 12.6577 18.4573L9.4126 21.7182C9.03869 22.0939 8.43246 22.0939 8.05855 21.7182L3.28043 16.9168ZM7.22702 15.3588C6.93412 15.0659 6.45925 15.0659 6.16636 15.3588C5.87346 15.6517 5.87346 16.1266 6.16636 16.4195L8.28768 18.5408C8.58057 18.8337 9.05544 18.8337 9.34834 18.5408C9.64123 18.2479 9.64123 17.773 9.34834 17.4802L7.22702 15.3588Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaw);
export default __webpack_public_path__ + "static/media/saw.ed58666998754b43234c542338287f57.svg";
export { ForwardRef as ReactComponent };